import { Colours, Sizes, Fonts } from '../../../style_helpers'

const dropdownHeight = Sizes(12)
const dropdownPadding = `0 ${Sizes(24)} 0 ${Sizes(0)}`
const shadow = '0 2px 10px 0 rgba(0, 0, 0, 0.15)'

export default {
  container: {
    base: {
      position: 'relative',
      display: 'inline-block',
      cursor: 'pointer'
    },

    disabled: {
      cursor: 'not-allowed'
    }
  },

  dropdown: {
    base: {
      backgroundColor: Colours('white', '300'),
      fontFamily: Fonts('gibson'),
      fontSize: Sizes(0),
      height: dropdownHeight,
      lineHeight: dropdownHeight,
      color: Colours('grey', '500'),
      padding: dropdownPadding,
      width: Sizes(102),
      textAlign: 'left',
      borderRadius: '5px',
      transition: 'none',
      cursor: 'pointer'
    },

    open: {
      borderRadius: '5px 5px 0 0'
    },

    alpha: {
      base: {
        border: `2px solid ${Colours('uiBlue', '300')}`
      },

      disabled: {
        color: Colours('grey', '200'),
        border: `2px solid ${Colours('grey', '100')}`,
        cursor: 'not-allowed'
      }
    },

    bravo: {
      base: {
        border: 'none'
      },

      disabled: {
        backgroundColor: Colours('grey', '100'),
        color: Colours('grey', '200'),
        cursor: 'not-allowed'
      }
    }
  },

  placeholder: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    lineHeight: dropdownHeight,
    padding: dropdownPadding,
    pointerEvents: 'none',
    color: Colours('grey', '200')
  },

  dropdownList: {
    base: {
      zIndex: 2,
      position: 'absolute',
      left: 0,
      right: 0,
      marginTop: '-2px',
      padding: 0,
      listStyle: 'none',
      textAlign: 'left',
      backgroundColor: Colours('white', '300'),
      maxHeight: Sizes(157),
      overflowY: 'scroll'
    },

    alpha: {
      border: `2px solid ${Colours('uiBlue', '300')}`
    },

    bravo: {
      borderTop: `2px solid ${Colours('uiBlue', '300')}`,
      boxShadow: shadow,
      WebkitBoxShadow: shadow,
      MozBoxShadow: shadow
    }
  },

  icon: {
    base: {
      position: 'absolute',
      top: Sizes(-1),
      right: Sizes(0),
      width: Sizes(0),
      height: Sizes(0),
      pointerEvents: 'none'
    },

    alpha: {
      color: Colours('white', '300')
    },

    bravo: {
      color: Colours('uiBlue', '300')
    },

    disabled: {
      color: Colours('grey', '200')
    }
  },

  iconContainer: {
    base: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      width: Sizes(17),
      borderRadius: '0 5px 5px 0',
      borderLeft: `2px solid ${Colours('uiBlue', '300')}`,
      pointerEvents: 'none'
    },

    alpha: {
      base: {
        backgroundColor: Colours('uiBlue', '300')
      },

      disabled: {
        backgroundColor: Colours('grey', '100'),
        borderLeft: `2px solid ${Colours('grey', '100')}`
      }
    },

    bravo: {
      base: {
        backgroundColor: Colours('white', '300')
      },

      disabled: {
        backgroundColor: Colours('grey', '100'),
        borderLeft: `2px solid ${Colours('grey', '200')}`
      }
    }
  }
}
